export const CsrfToken = document.querySelector('[name="csrf-token"]')?.getAttribute('content')
